import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ComboBox, RegionsSelector, Text } from '@reveni-io/reveni-ui'

import { groupRegionsByContinent } from '@/common/helpers/helpers'
import AdditionalCriteriaSelector from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/components/AdditionalCriteriaSelector/AdditionalCriteriaSelector'
import configurationServices from '@/configuration/services/services'

import { errorTypes } from '../constants'
import { visibilityOptions } from './constants'
import * as Styles from './styles'

const ShippingMethodAvailability = ({
  regions,
  shippingMethodRegions,
  onChange,
  errors = [],
  visibility,
  storeId,
  availabilityCriterionIds,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const handleChangeRegions = regions => {
    onChange({ regions })
  }

  const handleChangeVisibility = e => {
    onChange({ visibility: e.target.value })
  }

  const getRegionErrorMessage = () => {
    if (errors?.find(error => error.type === errorTypes.invalidRegionForCarrierService)) {
      return t(
        'Algunas regiones no son compatibles con el servicio logístico seleccionado. Seleccione otras regiones o elija otro servicio logístico.'
      )
    }

    if (!shippingMethodRegions?.length) {
      return t('Al menos una región debe estar seleccionada')
    }
  }

  const getRegionErrorType = () => {
    if (errors?.find(error => error.type === errorTypes.invalidRegionForCarrierService)) {
      return errorTypes.invalidRegionForCarrierService
    }

    if (errors?.find(error => error.type === errorTypes.regionsEmpty)) {
      return errorTypes.regionsEmpty
    }
    return null
  }

  return (
    <Styles.Container id={getRegionErrorType()}>
      <Text type="titleS">{t('Disponibilidad')}</Text>
      <ComboBox
        label={t('Visibilidad')}
        menuItems={visibilityOptions.map(o => ({ ...o, label: t(o.label) }))}
        value={visibility}
        handleChange={handleChangeVisibility}
      />
      <RegionsSelector
        label={t('Disponible en')}
        regions={groupRegionsByContinent(regions || []) || []}
        value={shippingMethodRegions}
        onChange={handleChangeRegions}
        helperText={getRegionErrorMessage()}
        error={getRegionErrorType()}
        inputBackgroundColor={theme.colors.background.secondary}
      />
      <AdditionalCriteriaSelector
        storeId={storeId}
        selectedCriterionIds={availabilityCriterionIds}
        onChange={onChange}
        getCriteriaService={configurationServices.getShippingAvailabilityCriteria}
      />
    </Styles.Container>
  )
}

export default ShippingMethodAvailability
